<template>
  <span class="input-span-container" :style="{
    float:content.inputW?'right':''
  }">{{ content.defaultText }}<span
      :ref="content.key"
      class="span-input"
      :class="seat.length >= 10 ? 'span-input-width' : ''"
      contenteditable
      @click.stop="(e)=> { e.stopPropagation(); }"
      @blur="blur"
      @input="input"
      @focus="focus"
      :style="{
        width:content.inputW?'430rem':'auto',
        display:content.inputW?'inline-block':'',
        borderBottom:content.inputW?'1rem solid #999999':'',
        textAlign:content.inputW?'left':'',
      }"
    ></span><span class="span-seat" @click.stop="clickSeat" v-html="seat" v-if="!content.inputW" ></span>
  </span>
</template>
<script>
/*
可输入文本
*/
export default {
  name: "text-input",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      seat: '',
    }
  },
  mounted() {
    // 半角空格 \u0020  全角空格 \u3000
    this.seat = new Array(10).fill("\u0020").join('')
    this.$bus.$on('reset', key => {
      this.reset(key)
    });
  },
  beforeDestroy() {
    // 销毁自定义事件
    this.$bus.$off(['reset']);
  },
  methods: {
    clickSeat() {
      console.log(this.$refs[this.content.key])
      this.$refs[this.content.key] && this.$refs[this.content.key].focus();
    },
    // 聚焦时定位光标位置
    focus() {
      setTimeout(() => {
        this.setFocus(this.content.key, this.content.text.length);
      }, 0);
      document.addEventListener('keydown', function(e) {
        if(e.keyCode==13){
          e.preventDefault();//禁用回车的默认事件
        }
      })
    },
    // 失焦时再赋值一遍
    blur() {
      let obj = this.$refs[this.content.key];
      let textValue = obj.innerText
      
      // this.$set(this.questionData[questionIndex].content[index], 'text', textValue);
      document.removeEventListener('keydown', function(e) {
        if(e.keyCode==13){
          e.preventDefault();//禁用回车的默认事件
        }
      })
    },
    // 输入时进行赋值
    input() {
      let obj = this.$refs[this.content.key];
      let textValue = obj.innerText;
      
      // this.$set(this.questionData[questionIndex].content[index], 'text', textValue);

      let seatValue = ''
      if(10 - textValue.length > 0) {
        seatValue = new Array(10 - textValue.length).fill("\u0020").join('')
      }
      this.seat = seatValue;
    },
    // 聚焦后把光标放到最后
    setFocus(key, index) {
      let obj = this.$refs[key];

      if (document.createRange) {
        // 获取选定对象
        let selection = getSelection();
        let range = document.createRange();

        range.setStart(obj.firstChild || obj, index);
        range.setEnd(obj.firstChild || obj, index);
        selection.removeAllRanges();
        selection.addRange(range);
      }
    },
    reset(key) {
      if(this.content.key.indexOf(key) > -1) {
        let obj = this.$refs[this.content.key];
        obj.innerHTML = '';
        this.input()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.input-span-container{
  text-decoration: underline;
  word-wrap: break-word;
  // word-break: normal;
  // word-break: break-all;
  
  .span-input{
    user-select: none;
    text-align: center;
    outline: none;
    line-height: initial;
  }
  .span-input-width{
    display: inline-block;
    min-width: 1px;
  }
  .span-seat{
    user-select: none;
    white-space: pre;
    white-space: break-spaces;
  }
}
</style>